module.exports = __webpack_public_path__ + "media/newJob.de7c0cf3.mp3";